import React from "react";
import { Modal } from "react-bootstrap";
import Icons from "../../../assets/icons";

const QuestionPaperModal = ({ show, onClose, mainQuestions = [] }) => {
    const questionImagePlaceholders = (htmlContent) => {
        const modifiedHtmlContent = htmlContent?.replace(/<img\s+src=Image\[\d+\]>/g, '');
        return modifiedHtmlContent;
    };
    return (
        <Modal
            show={show}
            onHide={onClose}
            backdrop="static"
            className="question_papers_modal"
            centered
            size="lg"
        >
            <Modal.Header>
                <Modal.Title>
                    <h4>Question Paper</h4>
                    <span className="cross_icon">
                        <img src={Icons.CrossW} alt="" className="img-fluid" onClick={onClose} />
                    </span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="questions_paper_lists">
                    <ul type="none">
                        {
                            mainQuestions?.map((d, i) => (
                                <li className="d-flex align-items-baseline">
                                    <div className="ques_number">
                                        <h6>Q{i + 1}</h6>
                                    </div>
                                    <div className="ques_text">
                                        <p style={{ marginLeft: (i + 1) > 99 ? '10px' : '0' }} dangerouslySetInnerHTML={{ __html: questionImagePlaceholders(d?.question?.questionText) }}></p>
                                        {/* <p>{d?.question?.questionText}</p> */}
                                        {
                                            d?.question?.questionImage && d?.question?.questionImage.length > 0 && d?.question?.questionImage[0] && (
                                                <img
                                                    src={d?.question?.questionImage[0]}
                                                    alt=""
                                                    className="img-fluid"
                                                />
                                            )
                                        }

                                    </div>
                                </li>
                            ))
                        }

                    </ul>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default QuestionPaperModal